import { useHistory } from "react-router-dom"
import { NewBreadcrumbsHeader } from "../../views/atoms/BreadcrumbsHeader"
import Breadcrumb from "../../views/atoms/Breadcrumb"
import React from "react"
import { ICategory, ISubCategory } from "../../../contentful-types"
import { useReadLearnLinks } from "./ReadLearnLinks"
import { useIntl } from "react-intl"

type BreadcrumbsProps = {
  category: ICategory
  subcategory?: ISubCategory
}

export function Breadcrumbs({ category, subcategory }: BreadcrumbsProps): JSX.Element {
  const history = useHistory()
  const { categoryLink, subCategoryPageLink } = useReadLearnLinks({ category, subCategory: subcategory })
  const intl = useIntl()
  const formattedMainBreadcrumb = intl.formatMessage({ defaultMessage: "Read & learn" })

  const breadcrumbs = [
    <Breadcrumb
      key="read-learn-main-breadcrumb"
      title={formattedMainBreadcrumb}
      isActive={false}
      onClick={() => history.push("/read")}
    />,
    <Breadcrumb
      key="read-learn--cat-breadcrumb"
      title={category?.fields?.title}
      isActive={false}
      onClick={() => history.push(categoryLink)}
    />
  ]

  if (subcategory) {
    breadcrumbs.push(
      <Breadcrumb
        key="read-learn--subcat-breadcrumb"
        title={subcategory?.fields?.title}
        isActive
        onClick={() => history.push(subCategoryPageLink)}
      />
    )
  }

  return <NewBreadcrumbsHeader breadcrumbs={breadcrumbs} />
}
